__webpack_require__.p = "https://baomoi-static.bmcdn.me/wap-v2/prod/v0.11.19/_next/";